import React from "react";
import { Grid, Skeleton } from "@mui/material";

const CommentSkeleton: React.FC = () => {
  return (
    <Grid item container gap={2} alignItems="flex-start">
      <Skeleton variant="circular" width="28px" height="28px" />
      <Grid item width={"auto"} flexGrow={1} paddingLeft={1} paddingBottom={2}>
        <Skeleton variant="rounded" width="auto" height="60px" />
      </Grid>
    </Grid>
  );
};

export default CommentSkeleton;
